<template>
  <div
    :class="[
      'SideBySideCmp',
      { intersected: intersected, imgContain: contain },
    ]"
  >
    <div class="container">
      <div
        class="row flex-column flex-md-row align-items-md-center position-relative"
      >
        <div
          v-if="
            themeVariant.includes('image-left') ||
            xsOnly ||
            (mdAndDown && themeVariant.includes('signature'))
          "
          :class="[
            'col-12',
            {
              'col-md-5':
                !themeVariant.includes('with-carousel') &&
                !themeVariant.includes('signature'),
              'col-md-6 col-lg-5': themeVariant.includes('with-carousel'),
              'col-lg-6': themeVariant.includes('image-sticky'),
              'offset-md-1':
                !themeVariant.includes('image-sticky') &&
                !themeVariant.includes('with-carousel'),
              'offset-lg-1': themeVariant.includes('with-carousel'),
              'col-md-10 col-lg-5': themeVariant.includes('signature'),
            },
          ]"
        >
          <div class="image-container">
            <slider-cmp-extended
              v-if="
                themeVariant.includes('with-carousel') &&
                themeVariant.includes('product-detail-variant')
              "
              :data-bootstrap-container-classes="['container-fluid', 'px-0']"
              :data-component-slides="true"
              :data-options="{
                observer: true,
                slidesPerView: 1,
                enabled: $slots.carousel.length === 1 ? false : true,
              }"
              @active-index-change="productDetailSliderIndex = $event"
              @click.native="onProductDetailSliderClick"
            >
              <template #components>
                <slot name="carousel" />
              </template>
            </slider-cmp-extended>
            <button
              v-if="
                themeVariant.includes('with-carousel') &&
                themeVariant.includes('product-detail-variant')
              "
              class="product-detail-zoom-btn"
              @click="$emit('product-image-click', productDetailSliderIndex)"
            >
              <svg>
                <use href="#icon-plus" />
              </svg>
            </button>
            <slider-cmp-extended
              v-else-if="themeVariant.includes('with-carousel')"
              :data-bootstrap-container-classes="['container-fluid', 'px-0']"
              :data-component-slides="true"
              :data-options="{
                observer: true,
                slidesPerView: 1,
                navigation: false,
                enabled: $slots.carousel.length === 1 ? false : true,
              }"
            >
              <template #custom-swipe-icon>
                <svg>
                  <use href="#icon-scroller" />
                </svg>
              </template>
              <template #components>
                <slot name="carousel" />
              </template>
            </slider-cmp-extended>
            <figure v-else :class="['side-image', dataShadowClass]">
              <slot name="image" />
            </figure>
          </div>
        </div>
        <div
          :class="[
            'col-12',
            {
              'col-md-6 col-lg-5': themeVariant.includes('image-sticky'),
              'col-md-5':
                !themeVariant.includes('image-sticky') &&
                !themeVariant.includes('with-carousel') &&
                !themeVariant.includes('signature'),
              'col-md-6 col-lg-5 col-xl-4 offset-xl-1':
                themeVariant.includes('with-carousel'),
              'offset-md-1':
                themeVariant.includes('image-right') &&
                !themeVariant.includes('with-carousel') &&
                !themeVariant.includes('signature'),
              'offset-lg-1':
                themeVariant.includes('image-right') &&
                themeVariant.includes('with-carousel'),
              'col-md-10 offset-md-1 col-lg-5':
                themeVariant.includes('signature'),
              'offset-lg-0':
                themeVariant.includes('image-left') &&
                themeVariant.includes('signature'),
            },
          ]"
        >
          <div class="text-container">
            <slot />
            <div
              v-if="themeVariant.includes('signature')"
              class="signature-wrapper a-support text-color-bronze font-medium"
            >
              <div class="quote-wrapper">
                <div class="font-bold"><slot name="quote-author" /></div>
                <slot name="quote-author-restaurant" />
              </div>
              <div class="signature-image-wrapper">
                <slot name="signature-image" />
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            themeVariant.includes('image-right') &&
            ((mdAndUp && !themeVariant.includes('signature')) ||
              (lgAndUp && themeVariant.includes('signature')))
          "
          :class="[
            {
              'col-md-5':
                !themeVariant.includes('with-carousel') &&
                !themeVariant.includes('signature'),
              'col-md-6 col-lg-5 offset-xl-1':
                themeVariant.includes('with-carousel'),
              'col-lg-6': themeVariant.includes('image-sticky'),
              'col-lg-5': themeVariant.includes('signature'),
            },
          ]"
        >
          <div class="image-container">
            <slider-cmp-extended
              v-if="themeVariant.includes('with-carousel')"
              :data-bootstrap-container-classes="['container-fluid', 'px-0']"
              :data-component-slides="true"
              :data-options="{
                observer: true,
                slidesPerView: 1,
                navigation: false,
                enabled: $slots.carousel.length === 1 ? false : true,
              }"
            >
              <template #custom-swipe-icon>
                <svg>
                  <use href="#icon-scroller" />
                </svg>
              </template>
              <template #components>
                <slot name="carousel" />
              </template>
            </slider-cmp-extended>
            <figure v-else :class="['side-image', dataShadowClass]">
              <slot name="image" />
            </figure>
          </div>
        </div>
        <div
          v-if="themeVariant.includes('animated')"
          v-intersect.once="onIntersect"
          class="intersect"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SliderCmpExtended from './slider-cmp-extended';
import { xsOnly, mdAndDown, mdAndUp, lgAndUp } from '@/helpers/breakpoints.js';
import Intersect from '@frankhoodbs/lib/src/directives/intersect';
import { castPropToType } from '@/helpers/cms-support';

export default {
  name: 'SideBySideCmp',
  components: { SliderCmpExtended },
  directives: {
    Intersect,
  },
  props: {
    dataShadowClass: {
      type: String,
      default: 'shadow-hard',
    },
    dataContain: {
      type: [String, Boolean],
      default: false,
    },
  },
  setup() {
    return { xsOnly, mdAndDown, mdAndUp, lgAndUp, castPropToType };
  },
  data() {
    return {
      themeVariant: [],
      intersected: false,
      productDetailSliderIndex: 0,
    };
  },
  computed: {
    contain() {
      return this.dataContain
        ? this.castPropToType(this.dataContain, 'boolean')
        : false;
    },
  },
  mounted() {
    if (this.$el.classList.contains('product-detail-variant')) {
      this.themeVariant.push('product-detail-variant');
      this.$el.classList.add(
        'image-left',
        'with-carousel',
        'animationForTransparentsImgs'
      );
    }

    if (this.$el.classList.contains('animated')) {
      this.themeVariant.push('animated');
    }
    if (this.$el.classList.contains('image-left')) {
      this.themeVariant.push('image-left');
    } else if (this.$el.classList.contains('image-right')) {
      this.themeVariant.push('image-right');
    } else {
      this.themeVariant.push('image-left');
    }
    if (this.$el.classList.contains('image-sticky')) {
      this.themeVariant.push('image-sticky');
    } else if (this.$el.classList.contains('with-carousel')) {
      this.themeVariant.push('with-carousel');
    }

    if (
      this.$el.classList.contains('image-sticky') &&
      (this.$el.classList.contains('image-right') ||
        this.$el.classList.contains('image-left'))
    ) {
      this.$el.classList.add('animationForTransparentsImgs');
    }

    if (this.$el.classList.contains('signature')) {
      this.themeVariant.push('signature');
    }
  },
  methods: {
    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.intersected = true;
      }
    },
    onProductDetailSliderClick(event) {
      if (!event.target.closest('.swiper-button-prev, .swiper-button-next')) {
        this.$emit('product-image-click', this.productDetailSliderIndex);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.SideBySideCmp {
  .side-image {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;

    @include media-breakpoint-up(lg) {
      width: calc(
        100% + var(--#{$variable-prefix}gutter-x, #{$grid-gutter-width})
      );
    }

    img {
      width: 100%;
      height: auto;
      transition: transform 1s;
      transform: scale(1.2);
    }

    &:hover {
      img {
        transform: scale(1);
      }
    }
  }

  .text-container {
    padding-top: 24px;

    @include media-breakpoint-up(md) {
      padding-top: 0;
    }

    .TitleTextCmp {
      --title-text-text-align: left;
      --title-text-icon-wrapper-padding: 0 0 8px;
      --title-text-overtitle-wrapper-padding: 0 0 8px;
      @include override-responsive-typography-properties(
        $font-secondary,
        n-heading-3,
        --title-text-title-wrapper
      );

      @include media-breakpoint-up(md) {
        --title-text-icon-wrapper-padding: 0 0 24px;
      }
    }
  }

  &.image-left {
    .text-container {
      @include media-breakpoint-up(md) {
        padding-left: 16px;
      }

      @include media-breakpoint-up(lg) {
        padding-left: 80px;
      }
    }
  }

  &.image-right {
    .side-image {
      @include media-breakpoint-up(lg) {
        margin-left: calc(
          var(--#{$variable-prefix}gutter-x, #{$grid-gutter-width}) * -1
        );
      }
    }

    .text-container {
      @include media-breakpoint-up(md) {
        padding-right: 16px;
      }

      @include media-breakpoint-up(lg) {
        padding-right: 80px;
      }
    }
  }

  &.image-sticky {
    .image-container {
      @include media-breakpoint-up(md) {
        position: relative;
        height: 238px;

        .side-image {
          position: absolute;
          top: 0;
          width: 50vw !important;
          height: 100% !important;

          img {
            width: 100% !important;
            height: 100% !important;
            object-fit: cover;
          }
        }
      }

      @include media-breakpoint-up(lg) {
        height: 358px;
      }

      @include media-breakpoint-up(xl) {
        height: 530px;
      }
    }

    &.image-left {
      .image-container {
        @include media-breakpoint-up(md) {
          left: 0;

          .side-image {
            border-radius: 0 8px 8px 0;
            right: 0;
          }
        }
      }

      .text-container {
        @include media-breakpoint-up(lg) {
          padding-left: 40px;
        }
      }
    }

    &.image-right {
      .image-container {
        @include media-breakpoint-up(md) {
          right: 0;

          .side-image {
            border-radius: 8px 0 0 8px;
            left: 0;
          }
        }

        @include media-breakpoint-up(lg) {
          .side-image {
            margin-left: 0;
          }
        }
      }

      .text-container {
        @include media-breakpoint-up(lg) {
          padding-right: 40px;
        }
      }
    }

    .TitleTextCmp {
      --title-text-overtitle-wrapper-padding: 0;

      @include media-breakpoint-up(md) {
        @include override-responsive-typography-properties(
          $font-secondary,
          n-heading-2,
          --title-text-title-wrapper
        );
      }
    }
  }

  &.with-carousel {
    .text-container {
      padding: 40px 0 0 !important;

      @include media-breakpoint-up(md) {
        padding: 0 !important;
      }

      .TitleTextCmp {
        @include override-responsive-typography-properties(
          $font-secondary,
          n-heading-2,
          --title-text-title-wrapper
        );

        ::v-deep .CtaButtonCmpExtended:not(.btn-text):not(.btn-text-reversed) {
          @include media-breakpoint-down(md) {
            // btn-small
            --cta-button-padding: 12px 30px 11px;
          }

          span.text {
            @include media-breakpoint-up(lg) {
              white-space: nowrap;
            }
          }
        }
      }
    }

    ::v-deep .SliderCmpExtended {
      .slider-content {
        padding-bottom: 82px;

        @include media-breakpoint-up(md) {
          padding-bottom: 59px;
        }

        @include media-breakpoint-up(lg) {
          padding-bottom: 67px;
        }

        @include media-breakpoint-up(xl) {
          padding-bottom: 82px;
        }

        .swiper-container {
          .swiper-slide {
            height: auto;
            text-align: center;

            figure {
              display: inline-block;
              overflow: hidden;

              .ImageCmp {
                width: auto;
                max-width: 100%;
                height: auto;
                transition: transform 1s;
                transform: scale(1.2);
              }

              &:hover {
                .ImageCmp {
                  transform: scale(1);
                }
              }
            }
          }

          .swiper-pagination {
            padding: 40px 0 30px;

            @include media-breakpoint-up(md) {
              padding: 32px 0 15px;
            }

            @include media-breakpoint-up(lg) {
              padding: 40px 0 15px;
            }

            @include media-breakpoint-up(xl) {
              padding: 55px 0 15px;
            }
          }
        }
      }
    }
  }

  &.animationForTransparentsImgs {
    .side-image {
      img {
        transform: scale(1);
      }

      &:hover {
        img {
          transform: scale(0.9);
        }
      }
    }

    &.with-carousel {
      ::v-deep .SliderCmpExtended {
        .slider-content {
          .swiper-container {
            .swiper-slide {
              figure {
                .ImageCmp {
                  transform: scale(1);
                }

                &:hover {
                  .ImageCmp {
                    transform: scale(0.9);
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  &.signature {
    .signature-wrapper {
      display: flex;
      align-items: center;

      @include media-breakpoint-down(md) {
        flex-direction: column;
        gap: 8px;
      }

      .quote-wrapper {
        display: flex;
        flex-direction: column;
        flex: 1 0 50%;
        margin-right: auto;

        @include media-breakpoint-up(md) {
          margin-right: 0;
        }
      }

      .signature-image-wrapper {
        @include media-breakpoint-up(md) {
          display: flex;
          align-items: flex-start;
          justify-content: center;
          flex: 1 0 50%;
          height: 44px;
          overflow: visible;
        }

        @include media-breakpoint-up(lg) {
          align-items: center;
          height: 34px;
        }

        @include media-breakpoint-up(xl) {
          height: 44px;
        }

        img {
          max-width: 144px;
          height: auto;

          @include media-breakpoint-up(md) {
            margin-left: auto;
          }

          @include media-breakpoint-up(lg) {
            max-width: 200px;
          }

          @include media-breakpoint-up(xl) {
            max-width: 222px;
          }
        }
      }
    }

    .text-container {
      padding-top: 32px;

      @include media-breakpoint-up(lg) {
        padding-top: 0;
      }

      .TitleTextCmp {
        --title-text-text-align: left;
        --title-text-text-wrapper-color: #{$color-bronze};
        --title-text-text-wrapper-padding: 0 0 32px;
        @include override-responsive-typography-properties(
          $font-primary,
          a-paragraph-1,
          --title-text-text-wrapper
        );

        ::v-deep .text-wrapper {
          font-weight: $fh-semi-bold;
        }
      }
    }
  }

  /* Animation */
  &.animated {
    .intersect {
      position: absolute;
      top: 33.333%;
      right: 0;
      left: 0;
      height: 1px;
    }

    .image-container,
    .text-container {
      opacity: 0;
      transition: opacity 1.5s cubic-bezier(0.455, 0.03, 0.515, 0.955),
        transform 1s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    }

    &.image-left {
      .image-container {
        transform: translateX(-50vw);
      }

      .text-container {
        transform: translateX(50vw);
      }
    }

    &.image-right {
      .image-container {
        transform: translateX(50vw);
      }

      .text-container {
        transform: translateX(-50vw);
      }
    }

    &.intersected {
      .image-container,
      .text-container {
        opacity: 1;
        transform: translateX(0);
      }
    }
  }

  &.imgContain {
    .image-container {
      @include media-breakpoint-up(md) {
        .side-image {
          img {
            object-fit: contain;
          }
        }
      }
    }
  }

  &.product-detail-variant {
    --pd-pagination-space: 82px;

    @include media-breakpoint-up(md) {
      --pd-pagination-space: 59px;
    }

    @include media-breakpoint-up(lg) {
      --pd-pagination-space: 67px;
    }

    @include media-breakpoint-up(xl) {
      --pd-pagination-space: 82px;
    }

    .image-container {
      position: relative;
      cursor: pointer;
    }

    .product-detail-zoom-btn {
      position: absolute;
      top: calc(50% - var(--pd-pagination-space) / 2);
      left: 50%;
      transform: translate(-50%, -50%) scale(0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      background-color: $color-blue-10;
      border: none;
      border-radius: 50%;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.5s ease, transform 0.5s ease;
      z-index: 2;
      cursor: pointer;

      svg {
        width: 24px;
        height: 24px;
        color: $color-blue;
      }
    }

    .image-container:hover .product-detail-zoom-btn {
      opacity: 1;
      pointer-events: auto;
      transform: translate(-50%, -50%) scale(1);
    }

    ::v-deep .SliderCmpExtended {
      .slider-content {
        padding-bottom: var(--pd-pagination-space);
      }

      .swiper-slide {
        display: flex;
        align-items: center;
      }

      .swiper-button-prev,
      .swiper-button-next {
        top: calc(50% - var(--pd-pagination-space) / 2);
      }

      .swiper-button-prev {
        left: 0;
      }

      .swiper-button-next {
        right: 0;
      }
    }
  }
}
</style>
